import { getContributorSlug } from "@cappelendamm/utils/slugify";
import { createClient } from "../crystallize/client.js";
import { getContributorsByScidQuery as getContributorsByScidQuery } from "./author.discovery.js";
import { filterDuplicates, filterNullArrays } from "@cappelendamm/utils/array";
import { getTopicType } from "../crystallize/topics/selectors.js";
async function getContributorsByScid({ scids }, config) {
    if (scids.length === 0)
        return [];
    const crystallizeClient = createClient(config);
    const result = await crystallizeClient.discovery.request(getContributorsByScidQuery, { scids });
    return result.browse?.bidragsyter?.hits ?? [];
}
export async function getContributorData({ scids }, config) {
    const contributors = await getContributorsByScid({ scids: scids.map(Number) }, config);
    return contributors
        .filter((contributor) => !!contributor)
        .map((contributor) => ({
        shops: getContributorShops(contributor.topics),
        objectID: `${contributor.scid}`,
        pimId: contributor.itemId,
        scid: contributor.scid,
        imageUrl: contributor.bilde?.find((image) => image?.url)?.url ?? null,
        slug: getContributorSlug({
            name: contributor.name ?? null,
            scid: contributor.scid ?? "",
        }),
        fullName: contributor.name,
        firstName: contributor.fornavn,
        lastName: contributor.etternavn,
        indexedAt: contributor.etternavn?.at(0),
    }));
}
function getContributorShops(topics) {
    const shopPaths = filterDuplicates(filterNullArrays(topics).filter((topicPath) => getTopicType(topicPath) === "shop"));
    return shopPaths.map((path) => ({ path }));
}
